import React from 'react'
import HospitalSignup from '../../components/HospitalSignup/HospitalSignup'

function HospitalSignupPage() {
  return (
    <HospitalSignup/>
  )
}

export default HospitalSignupPage